import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import color from '../../../config/colors.json';

const buttonBaseStyle = css`
    height: ${({ height }) => height};
    width: ${({ fit }) => (fit ? '' : '100%')};
    margin: ${({ margin }) => margin};
    display:  ${({ display }) => (display || 'block')};
    border: none;
    color: ${({ textColor }) => (textColor || color.light)};
    border-radius: ${({ borderRadius }) => (borderRadius || '8px')};
    font-size:  ${({ fontSize }) => fontSize};
    line-height: ${({ lineheight }) => lineheight};
    padding: ${({ padding }) => padding};
    transition: .3s;
    text-align: center;
    box-shadow: ${({ shadow }) => (shadow ? '0 2px 3px #00000029' : '')};
    border: ${({ backgroundcolor }) => (`1px solid ${backgroundcolor}` || `1px solid ${color.redButtons}`)};
    background-color: ${({ backgroundcolor }) => backgroundcolor || color.redButtons};
    text-transform: ${({ uppercase }) => (uppercase ? 'uppercase' : 'unset')};
    font-family: 'Poppins', sans-serif;
    font-weight: ${({ fontWeight }) => (fontWeight || 'bold')};
    &:disabled, button[disabled] {
        opacity: .8;
        cursor: not-allowed;
        background-color: ${color.lightPink};
        border: ${color.lightPink};
    }
    &:hover {
        transition: .3s;
        opacity: .8;
        color: ${({ hoverColor }) => (hoverColor || color.light)};
        font-style: normal;
        text-decoration: none;
    }
    &:focus {
        outline: 0;
    }
    ${({ theme }) => theme === 'light' && `
        background-color: ${color.lightGrey2};
        border: 1px solid ${color.lightGrey2};
        color: ${color.dark};
        &:hover {
            color: ${color.dark}; 
        }
    `}
    ${({ theme }) => theme === 'light2' && `
        background-color: ${color.light};
        border: 1px solid ${color.light};
        color: ${color.dark};
        &:hover {
            color: ${color.dark}; 
        }
    `}
    ${({ theme }) => theme === 'light3' && `
        background-color: transparent;
        border: 1px solid ${color.lightRed};
        color: ${color.lightRed};
        &:hover {
            color: ${color.lightRed};
        }
    `}
    ${({ theme }) => theme === 'light4' && `
        background-color: #2ED68E;
        border: 1px solid #2ED68E;
        color: ${color.light};
        &:hover {
            color: ${color.light}; 
        }
    `}
    ${({ theme }) => theme === 'light5' && `
        background-color: #2ED68E;
        border: 1px solid #2ED68E;
        color: ${color.light};
        &:hover {
            color: ${color.light}; 
        }
    `}
    ${({ theme }) => theme === 'grey1' && `
        background-color: transparent;
        border: 1px solid ${color.greyMidias};
        color: ${color.greyMidias};
        &:hover {
            color: ${color.greyMidias}; 
        }
    `}
    ${({ theme }) => theme === 'red' && `
        background-color: transparent;
        border: 1px solid ${color.lightRed};
        color: ${color.lightRed};
        &:hover {
            color: ${color.lightRed}; 
        }
    `}
    ${({ theme }) => theme === 'red2' && `
        background-color: ${color.lightRed};
        border: 1px solid ${color.lightRed};
        color: ${color.light};
    `}
    ${({ bordered }) => bordered && `
        border: 1px solid ${color.darkGrey2};
    `}
`;

export const LinkStyle = styled(Link)`
    ${buttonBaseStyle}
`;

export const ButtonStyle = styled.button`
    ${buttonBaseStyle}
`;
